'use client';

import { useLocale } from 'next-intl';
import LocaleSwitcherSelect from './LocaleSwitcherSelect';

const languages = [
  {
    value: 'en',
    label: 'en',
  },
  // {
  //   value: 'de',
  //   label: 'de',
  // },
  {
    value: 'nl',
    label: 'nl',
  },
  {
    value: 'pl',
    label: 'pl',
  },
];

export default function LocaleSwitcher() {
  const locale = useLocale();

  return (
    <LocaleSwitcherSelect
      defaultLocale={languages.find((lang) => lang.value === locale) || languages[0]}
      languages={languages}
    />
  );
}
